import { fetchData } from "@app/Helpers";
import { globalCampaignIdent } from "../../Helpers";
import { getAppData } from "@app/storageFallback";

export const SESSION_STALE_TIME = 1000 * 60 * 5;
export const SESSION_CACHE_TIME = Infinity;

export function sendSessionPoll(successCallback, errorCallback, poll) {
    const payload = {
        campaign: {
            ident: globalCampaignIdent
        },
        session: {
            uuid: getAppData("sessionUUID")
        },
        poll: poll
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/session/poll",
        payload,
        successCallback,
        errorCallback,
        controller: controller,
    });
}

export function describeSession(successCallback, errorCallback) {
    const payload = {
        campaign: {
            ident: globalCampaignIdent
        },
        session: {
            uuid: getAppData("sessionUUID")
        }
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/session/describe",
        payload,
        successCallback,
        errorCallback,
        shouldThrowError: false,
        controller: controller,
    });
}

export function createSession(catalogues, successCallback, errorCallback) {
    const payload = {
        campaign: {
            ident: globalCampaignIdent
        },
        catalogues: catalogues,
        marketingConsent: true
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/session/create",
        payload,
        successCallback,
        errorCallback,
        controller: controller,
    });
}

export function updateSession(ident, form, successCallback, errorCallback) {
    if((form?.ident === "phone" || form?.ident === "shipping_address_phone") && form?.data?.mobilePhone) {
        const prefixedPhone = form?.data?.mobilePhone;
        form.data.mobilePhone = prefixedPhone
    }

    const payload = {
        session: {
            uuid: getAppData("sessionUUID")
        },
        campaign: {
            ident: globalCampaignIdent
        },
        catalogue: {
            ident: ident
        },
        form: form
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/session/update-form",
        payload,
        successCallback,
        errorCallback,
        controller: controller,
    });
}

export function completeSession(successCallback, errorCallback) {
    const payload = {
        session: {
            uuid: getAppData("sessionUUID")
        },
        campaign: {
            ident: globalCampaignIdent
        }
    }

    const controller = new AbortController();

    return fetchData({
        endpoint: "/session/complete",
        payload,
        successCallback,
        errorCallback,
        controller: controller,
    });
}
